import { enqueueSnackbar, OptionsWithExtraProps } from 'notistack';

import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';

export class NotistackSnackbarGateway implements SnackbarGateway {
  success(
    message: string | React.ReactNode,
    extraProps?: OptionsWithExtraProps<'success'>,
  ) {
    enqueueSnackbar(message, { variant: 'success', ...extraProps });
  }

  error(
    message: string | React.ReactNode,
    extraProps?: OptionsWithExtraProps<'error'>,
  ) {
    enqueueSnackbar(message, { variant: 'error', ...extraProps });
  }

  warning(
    message: string | React.ReactNode,
    extraProps?: OptionsWithExtraProps<'warning'>,
  ) {
    enqueueSnackbar(message, { variant: 'warning', ...extraProps });
  }
}
